import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import theme from './styles/theme';

// Auth
import { AuthProvider } from './contexts/AuthContext';
import { ArtistsProvider } from './contexts/ArtistsContext';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Layout
import Layout from './components/layout/Layout';

// Artist Management Pages
import ExistingArtists from './components/artists/ExistingArtists';
import ArtistDetail from './components/artists/ArtistDetail';
import InviteArtist from './components/artists/InviteArtist';
import SentInvites from './components/artists/SentInvites';
import PendingRequests from './components/artists/PendingRequests';
import TestArtists from './components/artists/TestArtists';
import Collectors from './components/collectors/Collectors';
import CollectorDetail from './components/collectors/CollectorDetail';
import SupportTickets from './components/support/SupportTickets';
import ReportedConversations from './components/reports/ReportedConversations';
import Insights from './components/insights/Insights';
import PaymentSettings from './components/settings/PaymentSettings';
import Disputes from './components/disputes/Disputes';
import Shipping from './components/shipping/Shipping';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AuthProvider>
        <ArtistsProvider>
          <Router>
            <ProtectedRoute>
              <Routes>
                {/* Redirect from root to insights */}
                <Route path="/" element={<Navigate to="/insights" replace />} />
                
                {/* Main layout with nested routes */}
                <Route path="/" element={<Layout />}>
                  <Route path="/insights" element={<Insights />} />

                  {/* Artist management routes */}
                  <Route path="/artists" element={<Navigate to="/artists/existing" replace />} />
                  <Route path="/artists/existing" element={<ExistingArtists />} />
                  <Route path="/artists/existing/:artistId" element={<ArtistDetail />} />
                  <Route path="/artists/invite" element={<InviteArtist />} />
                  <Route path="/artists/sent-invites" element={<SentInvites />} />
                  <Route path="/artists/test-artists" element={<TestArtists />} />
                  <Route path="/artists/requests" element={<PendingRequests />} />
                  <Route path="/collectors" element={<Collectors />} />
                  <Route path="/collectors/:collectorId" element={<CollectorDetail />} />
                  <Route path="/support" element={<SupportTickets />} />
                  <Route path="/reports" element={<ReportedConversations />} />
                  <Route path="/disputes" element={<Disputes />} />
                  <Route path="/shipping" element={<Shipping />} />
                  <Route path="/settings/payments" element={<PaymentSettings />} />
                </Route>
              </Routes>
            </ProtectedRoute>
          </Router>
        </ArtistsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
